import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllPatrimonioAlertaManutencaoCadastro } from '../service';
import {
  LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO,
  LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_PENDING,
  LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS,
  LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllPatrimonioAlertaManutencaoCadastro(action) {
  yield put({ type: LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_PENDING })

  try {
    const list = yield call(findAllPatrimonioAlertaManutencaoCadastro)
    
    yield put({ type: LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS, list: list })
  } catch (error) {
    yield put({ type: LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_FAILURE })
  }
}

export default function* watchListAllPatrimonioAlertaManutencaoCadastro() {
  yield takeLatest(LIST_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO, sagaListAllPatrimonioAlertaManutencaoCadastro)
}
